import { FC, PropsWithChildren } from 'react';

interface ProjectDrawerSectionProps extends PropsWithChildren {
  title: string;
  className?: string;
}

export const ProjectDrawerSection: FC<ProjectDrawerSectionProps> = ({
  title,
  className = '',
  children,
}) => {
  return (
    <section className={`flex flex-col gap-2 ${className}`}>
      <p className="m-0! [font-size:var(--fs-l4)]! font-semibold text-(--neutral-black-NB900)!">
        {title}
      </p>

      {children}
    </section>
  );
};
